import config from '../config'

import queryString from 'query-string';

const boolean = require('boolean');

let PARSED_CONFIG = queryString.parse(location.search);

// PARSING URL

export var FBO_DEBUG = boolean(PARSED_CONFIG.fbodebug);

export var JSON_URL = PARSED_CONFIG.data != null ? JSON.parse(decodeURI(PARSED_CONFIG.data)) : {}

export var DEBUG     = boolean(PARSED_CONFIG.debug);

export var MODE  = PARSED_CONFIG.mode ? parseFloat(PARSED_CONFIG.mode) : null

export let CURRENT_MODE = MODE != null ? MODE : 0

export var SCENE = PARSED_CONFIG.scene ? parseFloat(PARSED_CONFIG.scene) : 0




// WEBPACK FOOTER //
// ./src/scripts/Trail/globals/constants.js